<template>
	<div class="inside_pages_right">
		<AuthorityManagement></AuthorityManagement>
		<div class="inside_pages_right_content">
			<!-- 角色成员管理 -->
			<div class="inside_pages_content_two">
				<div class="content_top_three">
					<div class="inside_pages_right_content_top_left">
						<el-button
							type="primary"
							plain
							size="mini"
							icon="el-icon-back"
							@click="$Common.pageJump('/authority_settings', 3)"
							>返回</el-button
						>
						<el-button
							type="primary"
              plain
							size="mini"
							icon="el-icon-circle-plus-outline"
							@click="openAddBox()"
							>添加成员</el-button
						>
					</div>
				</div>
				<div class="content_center_three">
					<el-table
						:data="responseData.list"
						height="100%"
						border
						style="width: 100%"
						@selection-change="selectListData"
					>
						<el-table-column type="selection" width="36" align="center">
						</el-table-column>
						<el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{
                  responseData.pageSize * (responseData.pageNum - 1) +
                    scope.$index +
                    1
                }}
              </template>
            </el-table-column>
						<el-table-column prop="userName" label="用户姓名" align="center">
						</el-table-column>
						<el-table-column prop="userPhone" label="联系方式" align="center" width="200">
						</el-table-column>
						<el-table-column label="操作" column-key="index" align="center" width="160">
							<template slot-scope="scope">
								<div class="text-center">
									<el-button
										type="danger"
										size="mini"
                                        plain
										icon="el-icon-circle-close"
										@click="delDataInfo(scope.row.userId)"
									>
										删除
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="content_bottom_three" v-if="responseData.total > 0">
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="responseData.pageNum"
						:page-sizes="[20, 30, 50, 100]"
						:page-size="20"
						layout="total, sizes, prev, pager, next, jumper"
						prev-text="上一页"
						next-text="下一页"
						:total="responseData.total"
					>
					</el-pagination>
				</div>
			</div>

			<el-dialog
				title="添加成员"
				:visible.sync="addBox"
				:modal-append-to-body="false"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				width="30%"
				center
			>
				<form class="form-horizontal">
					<div class="form-group options_box">
						<div class="col-sm-12">
                            <tree-common ref="treeCommon" :treeData='allTeachers'></tree-common>
						</div>
					</div>
				</form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addBox = false" size="mini"
						>取 消</el-button
					>
					<el-button
						type="primary"
						@click="addDataAction()"
						size="mini"
						>确 定</el-button
					>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import AuthorityManagement from '@/components/AuthorityManagement'
import TreeCommon from '@/components/TreeCommon'
export default {
	name: '',
	components: { AuthorityManagement,TreeCommon },
	props: {},
	data() {
		return {
			addBox: false,
			departmentHead: [],
			responseData: {
				pageNum: 1, // 第几页
				pageSize: 20, // 一页多少个
				total: 0, // 总条数
				pages: 0, // 总页数
				list: [], // 数据列表
			},

			requestData: {
				pageNum: 1,
				pageSize: 20,
			},
			addTeacherList: [],
			roleInfo: JSON.parse(sessionStorage.getItem('roleInfo')) || '',

			selectedListData: [],
			// 所有老师
			allTeachers: []
		}
	},
	watch: {},
	computed: {},
	methods: {
		delDataInfo(thisId = 0) {
			this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(async () => {
					if (thisId >= 1) {
						var requestData = {
							userId: thisId,
						}
					} else {
						if (this.selectedListData.length < 1) {
							this.$message({
								type: 'error',
								message: '请先选择您要删除的数据',
							})
							return false
						}
						var requestData = this.selectedListData
					}

					let res = await this.$Http.delRoleMember(requestData, true)
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: '删除成功!',
						})
						this.getDataList()
					} else if (res.code == 101) {
					} else {
						this.$message({
							type: 'error',
							message: res.messsage,
						})
					}
				})
				.catch(() => {})
		},
		openAddBox() {
			this.allTeachers = []
			this.getAllTeachers()
			this.addBox = true
		},
		async addDataAction() {
            let userList = this.$refs.treeCommon.$refs.tree.getCheckedKeys()
			if (userList.length > 0) {
                let req = userList.map((item)=>{
                let obj = {
                    roleId: this.roleInfo.roleId,
					userId: item,
                }
                return obj
            })
                let res = await this.$Http.addRoleMember(req)
                if (res.code == 200) {
                    this.$message({
                        type: 'success',
                        message: '添加成功',
                    })
                    // this.addTeacherList = []
                    this.addBox = false
                    this.getDataList()
                } else if (res.code == 101) {
                } else {
                    this.$message({
                        type: 'error',
                        message: res.messsage,
                    })
                }
                }else{
                    this.$message({
                        type: 'warning',
                        message: '请先选择您要添加的成员',
                    })
                    return false
                    
            }
		},
		handleSizeChange(data) {
			this.requestData.pageSize = data
			this.getDataList()
		},
		handleCurrentChange(data) {
			this.requestData.pageNum = data
			this.getDataList()
		},
		selectListData(data) {
			this.selectedListData = []
			data.forEach((element) => {
				this.selectedListData.push(element.id)
			})

			// console.log(this.selectedListData)
		},

		async getAllTeachers() {
			var _this = this
			let req = {
				pageSize: 10000,
				pageNum: 1,
				schoolId: parseInt(this.$store.state.schoolId),
				departmentId: '',
				userPhone: '',
				userName: '',
			}
			let res = await this.$Http.getTeacherList(req,true)
            if (res.code == 200) {
				if (res.data) {
                    let data = res.data.list || []
                    let newData = data.map((item)=>{
                        let obj = {
                            label:item.Name || '',
                            id:item.id||'',
                            leve:'2'
                        }
                        return obj
                    })
                    if (data.length > 0) {

                        this.allTeachers = [
                            {
                                label: '全部',
                                id: '00',
                                leve:'1',
                                children: newData,
                            },
                        ]
                    }
				} else {
					this.allTeachers = []
				}
			} else if (res.code == 101) {
					this.allTeachers = []
			} else {
					this.allTeachers = []
				this.$message({
					type: 'error',
					message: res.messsage || '',
				})
			}
		},
		// 获取数据列表
		async getDataList() {
			var parameData = {
				pageNum: this.requestData.pageNum,
				pageSize: this.requestData.pageSize,
				roleId: this.roleInfo.roleId,
			}
			let res = await this.$Http.getRoleMemberList(parameData, true)
			if (res.code == 200) {
				this.responseData.pageSize = res.data.pageSize
				this.responseData.pageNum = res.data.pageNum
				this.responseData.total = res.data.total
				this.responseData.pages = res.data.pages
				this.responseData.list = res.data.list
			} else if (res.code == 101) {
			} else {
				this.$message({
					type: 'error',
					message: res.messsage,
				})
			}
		},
	},
	created() {},
	mounted() {
		if (this.roleInfo == '') {
			this.$Common.pageJump('/authority_settings', 3)
		}
		this.getDataList()
	},
}
</script>
<style scoped>
@import '/css/base.css';
@import '/css/authority.css';
</style>
